module.exports = __webpack_public_path__ + "src/assets/games/33/wheel022.jpg";